import React, { useState, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { format } from "react-string-format";

import { Box, Tabs, Tab, Typography, Grid, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GiCancel } from "react-icons/gi";
import { GetApp } from "@mui/icons-material";

import CostCenterTable from "./MasterTables/CostCenterTable";
import AreaGroupTable from "./MasterTables/AreaGroupTable";
import EquipmentTypeTable from "./MasterTables/EquipmentTypeTable";
import { FaUpload } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";

import { downloadExcelTemplate, getExcelJsonData, uploadExcelFile } from "../../store/actions/MasterDataActions";
import BreakdownPlaceAndDetailTable from "./MasterTables/BreakdownPlaceAndDetailTable";
import EquipmentTable from "./MasterTables/EquipmentTable";

export default function Lists() {
    const ls = localStorage;
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    const { excelToListResponse, uploadExcelFileResponse } = useSelector(({ MasterData }) => MasterData);

    const [costCenterExcel, setCostCenterExcel] = useState([]);
    const [areaGroupExcel, setAreaGroupExcel] = useState([]);
    const [equipmentTypeExcel, setEquipmentTypeExcel] = useState([]);
    const [breakdownExcel, setBreakdownExcel] = useState([]);
    const [equipmentExcel, setEquipmentExcel] = useState([]);

    const [ccWarnings, setCcWarnings] = useState([]);
    const [areaWarnings, setAreaWarnings] = useState([]);
    const [breakdownWarnings, setBreakdownWarnings] = useState([]);
    const [eqTypeWarnings, setEqTypeWarnings] = useState([]);
    const [eqWarnings, setEqWarnings] = useState([]);

    const [disableExcel, setDisableExcel] = useState(false);
    const [disableUpload, setDisableUpload] = useState(true);
    const [disableCancel, setDisableCancel] = useState(true);

    const [fileChecksum, setFileChecksum] = useState("");
    const [openDialog, setOpenDialog] = useState(false);

    const [created, setCreated] = useState(0);
    const [read, setRead] = useState(0);
    const [updated, setUpdated] = useState(0);

    useEffect(() => {
        console.log(excelToListResponse);
        if (excelToListResponse?.resultObject) {
            console.log(excelToListResponse.resultObject.fileCheckSum.hash);
            setCostCenterExcel(excelToListResponse.resultObject.costCenter.content);
            setAreaGroupExcel(excelToListResponse.resultObject.area.content);
            setEquipmentTypeExcel(excelToListResponse.resultObject.equipmentType.content);
            setBreakdownExcel(excelToListResponse.resultObject.breakdown.content);
            setEquipmentExcel(excelToListResponse.resultObject.equipment.content);

            
            setFileChecksum(excelToListResponse.resultObject.fileCheckSum.hash);
            setDisableExcel(true);
            setDisableUpload(false);
        }
        excelToListWarnings(excelToListResponse);
    }, [excelToListResponse]);

    useEffect(() => {
        console.log(uploadExcelFileResponse);
        if (uploadExcelFileResponse.errorCode === 0) {
            setDefaultState();
            setOpenDialog(true);
            setRead(uploadExcelFileResponse.resultObject.readCount);
            setCreated(uploadExcelFileResponse.resultObject.createdCount);
            setUpdated(uploadExcelFileResponse.resultObject.updatedCount);
        }
    }, [uploadExcelFileResponse]);

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box margin={2}>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const cancelUpload = () => {
        setDefaultState();
        window.location.reload();
    };

    const getExcelTemplate = () => {
        dispatch(downloadExcelTemplate());
    };

    const excelToList = (event) => {
        if (event.target.files && event.target.files[0]) {
            let file = event.target.files[0];
            const formData = new FormData();
            formData.append("file", file);

            let payload = {
                data: formData,
            };

            console.log(payload);
            dispatch(getExcelJsonData(payload));
        }
    };

    const uploadExcel = () => {
        dispatch(uploadExcelFile(fileChecksum));
    };

    const setDefaultState = () => {
        setDisableExcel(false);
        setDisableUpload(true);
        setDisableCancel(true);
        setCostCenterExcel([]);
        setAreaGroupExcel([]);
        setEquipmentTypeExcel([]);
        setBreakdownExcel([]);
        setFileChecksum("");
        setCcWarnings([]);
        setAreaWarnings([]);
        setBreakdownWarnings([]);
        setEqTypeWarnings([]);
        //window.location.reload();
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };

    const excelToListWarnings = (excelToListResponse) => {
        console.log(excelToListResponse);
        if (excelToListResponse?.resultObject) {
            if (excelToListResponse.resultObject.costCenter.warnings) {
                setCcWarnings(excelToListResponse.resultObject.costCenter.warnings);
            }
            if (excelToListResponse.resultObject.area.warnings) {
                setAreaWarnings(excelToListResponse.resultObject.area.warnings);
            }
            if (excelToListResponse.resultObject.breakdown.warnings) {
                setBreakdownWarnings(excelToListResponse.resultObject.breakdown.warnings);
            }
            if (excelToListResponse.resultObject.equipmentType.warnings) {
                setEqTypeWarnings(excelToListResponse.resultObject.equipmentType.warnings);
            }
            if (excelToListResponse.resultObject.equipment.warnings) {
                setEqWarnings(excelToListResponse.resultObject.equipment.warnings);
            }
            setDisableCancel(false);
        }
    };

    const handleClose = () => {
        setOpenDialog(false);
        window.location.reload();
      };

    return (
        <div>
            <Grid container item md={12}>
                {/* Buttons */}
                <Grid container xs={12} sm={12} md={12} lg={12}>
                    <Grid item xs={3} sm={4} md={3} lg={2}></Grid> {/*spacer*/}
                    <Grid item xs={4} sm={4} md={4} lg={4}>
                        {/* Excel Button */}
                        <Tooltip title={t("ChooseExcelFile")}>
                            <IconButton id="cpm_IconButton_3" component="label" size="large">
                                <RiFileExcel2Fill id="cpm_CreateNewFolder" className={disableExcel ? "button disable" : "button success"} />
                                <input id="cpm_input" onChange={excelToList} type="file" style={{ display: "none" }} />
                            </IconButton>
                        </Tooltip>

                        {/* İptal Button */}
                        <Tooltip title={t("Cancel")}>
                            <IconButton component="label" onClick={cancelUpload} disabled={disableCancel} size="large">
                                <GiCancel className={disableCancel ? "button diable" : "button error"} />
                            </IconButton>
                        </Tooltip>

                        {/* Upload Button */}
                        <Tooltip title={t("DataUpload")}>
                            <IconButton component="label" size="large" onClick={uploadExcel} disabled={disableUpload}>
                                <FaUpload className={disableUpload ? "button disable" : "button enable"} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={3} sm={2} md={3} lg={4}></Grid> {/*spacer*/}
                    <Grid item xs={2} sm={2} md={2} lg={2}>
                        {/* Download Button */}
                        <Tooltip title={t("DownloadExcelTemplate")}>
                            <IconButton component="label" size="large">
                                <GetApp
                                    //disableUpload={disableUpload}
                                    style={{ fill: "#008000", width: "50px", height: "50px" }}
                                    onClick={getExcelTemplate}
                                />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
                {/* Tabs */}
                <Grid item xs={12} sm={12} md={12} lg={8}>
                    <Tabs style={{ height: "10px" }} value={value} onChange={handleChange} centered>
                        <Tab style={{border: "solid"}} label={t("CostCenter")} {...a11yProps(0)}></Tab>
                        <Tab style={{border: "solid"}} label={t("Area")} {...a11yProps(1)}></Tab>
                        <Tab style={{border: "solid"}} label={t("EquipmentType")} {...a11yProps(2)}></Tab>
                        <Tab style={{border: "solid"}} label={t("BreakdownPlaceAndDetail")} {...a11yProps(3)}></Tab>
                        <Tab style={{border: "solid"}} label={t("Equipment")} {...a11yProps(4)}></Tab>
                    </Tabs>
                </Grid>
            </Grid>

            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={(value) => {
                    setValue(value);
                }}
                enableMouseEvents
                style={{ height: "100%"}}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <CostCenterTable costCenterExcel={costCenterExcel} warnings={ccWarnings} />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <AreaGroupTable areaGroupExcel={areaGroupExcel} warnings={areaWarnings} />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <EquipmentTypeTable equipmentTypeExcel={equipmentTypeExcel} warnings={eqTypeWarnings} />
                </TabPanel>
                <TabPanel value={value} index={3} dir={theme.direction}>
                    <BreakdownPlaceAndDetailTable breakdownExcel={breakdownExcel} warnings={breakdownWarnings} />
                </TabPanel>
                <TabPanel value={value} index={4} dir={theme.direction}>
                    <EquipmentTable equipmentExcel={equipmentExcel} warnings={eqWarnings} />
                </TabPanel>
            </SwipeableViews>
            <div style={{width: "300px"}}>
                <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogTitle id="md_DialogTitle">{t("Information")}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="md_DialogDesc">
                            {format(t("MasterDataUploadInfo"), <b>{read}</b> , <b>{created}</b>, <b>{updated}</b> )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}
